import { render, staticRenderFns } from "./AssessmentApplicationStatus.vue?vue&type=template&id=edfe3e64&scoped=true"
import script from "./AssessmentApplicationStatus.vue?vue&type=script&lang=js"
export * from "./AssessmentApplicationStatus.vue?vue&type=script&lang=js"
import style0 from "./AssessmentApplicationStatus.vue?vue&type=style&index=0&id=edfe3e64&prod&scoped=true&lang=css"
import style1 from "./AssessmentApplicationStatus.vue?vue&type=style&index=1&id=edfe3e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe3e64",
  null
  
)

export default component.exports